export interface CategoryMenuItem {
  label: string
  to: string
  navId: string
  enTerm: string
}

const CATEGORY_GROUP_EN_TERM: Record<string, string> = {
  pharma: 'Pharma',
  practice_supply: 'Consumables',
  food: 'Pet Food',
}

export function useCategoryMenuItems() {
  const treeStore = useCategoryTreeStore()
  const categoryGroupStore = useCategoryGroup()
  const localePath = useLocalePath()
  const { locale, t } = useI18n()
  const categoryGroupReverseI18n = useCategoryI18nReverse('enum.product_category_group.')

  return computed<CategoryMenuItem[]>(() => {
    if (treeStore.roots.length > 0) {
      return treeStore.roots.map((node: CategoryTreeNode) => {
        const slug = treeStore.normalize(node.terms[locale.value] ?? node.terms.de ?? '')
        return {
          label: node.terms[locale.value] ?? node.terms.de ?? '',
          to: localePath(`/c/${slug}`),
          navId: `mobile_menu_category_${slug}`,
          enTerm: node.terms.en ?? node.terms.de ?? '',
        }
      })
    }

    if (!categoryGroupStore.isCategoryGroupsPending && categoryGroupStore.categoryGroup.length > 0) {
      const sorted = [...categoryGroupStore.categoryGroup].sort(sortByHandle(['pharma', 'practice_supply', 'food']))
      return sorted.map(cat => ({
        label: t(cat.i18nKey),
        to: localePath(`/${categoryGroupReverseI18n.translateNormalized(cat.handle)}`),
        navId: `mobile_menu_category_${cat.handle}`,
        enTerm: CATEGORY_GROUP_EN_TERM[cat.handle] ?? cat.handle,
      }))
    }

    return []
  })
}
